import ProductInventory from './components/productInventory';

/**
 * Renders the frontend display for the Product - Lookup Block.
 *
 * @param { string } root0
 * @param { number } root0.productsPerPage - Number of products to display per page.
 * @param { string } root0.countryCode     - Selected country code.
 *
 * @return { JSX.Element } Rendered frontend display.
 */
const FrontendDisplay = ( { productsPerPage, countryCode } ) => {
	return (
		<>
			<ProductInventory itemsPerPage={ productsPerPage } countryCode={ countryCode } />
		</>
	);
};

export default FrontendDisplay;
